import React from "react";

const Reference = () => {
  return (
    <div className="m-32">
      <h1 className="text-center mb-5 md:text-4xl font-extrabold ">
        Referanslarımız
      </h1>
      <p className="text-center font-medium text-xl mb-16">
        Daha fazla referans bilgisi almak için iletişime geçiniz
      </p>
      <div className="grid grid-cols-2 text-center md:grid-cols-12 gap-4">
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/1.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/2.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg object-contain"
            src="./referans/3.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/4.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/5.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/6.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/7.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/8.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/9.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/10.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/11.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/12.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/13.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/14.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/15.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/16.png"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/17.jpeg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/18.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/19.png"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/20.png"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/21.png"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/22.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/23.png"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/24.jpg"
            alt=""
          />
        </div>
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/25.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/26.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/27.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/28.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/29.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/30.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/31.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/32.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/33.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/34.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/35.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/36.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/37.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/38.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/39.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/40.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/41.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/42.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/43.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/44.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/45.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/46.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/47.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/48.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/49.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/50.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/51.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/52.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/53.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/54.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/55.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/56.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/57.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/58.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/59.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/60.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/61.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/62.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/63.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/64.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/65.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/66.jpg"
            alt=""
          />
        </div>{" "}
        <div>
          <img
            className="h-24 max-w-full rounded-lg"
            src="./referans/67.jpg"
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Reference;
